// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"cae1eaf7","169":"145f2162","204":"2136ea24","359":"f0262aeb","434":"454160f1","888":"9a7a0a7e"}[chunkId] + ".chunk.css";
};